/**
 * A3 : délai de retrait gratuit dépassé. Aucun montant ici : seulement des jours, comptés depuis la fin
 * du délai gratuit (`freeUntil`, calculée par le serveur dans le fuseau du garage).
 */
const DAY = 86_400_000;

/** Nombre de jours entamés depuis la fin du délai gratuit (0 s'il court encore). */
export function overdueDays(freeUntil: string | null | undefined, now: number = Date.now()): number {
  if (!freeUntil) return 0;
  const end = Date.parse(freeUntil);
  if (!Number.isFinite(end) || now <= end) return 0;
  return Math.max(1, Math.floor((now - end) / DAY));
}

/** « 1 j », « 3 j ». */
export const daysShort = (n: number) => `${n} j`;

/**
 * Délai dépassé pour un véhicule prêt, ni restitué ni exonéré. `storageState` (API, vague 6) fait foi
 * quand il est renvoyé ; sinon (API plus ancienne) on compare `freeUntil` à l'heure courante.
 */
export function isStorageOverdue(
  it: { status: string; freeUntil: string | null; storageState?: 'none' | 'running' | 'due_soon' | 'overdue' | undefined },
  opts: { waived?: boolean; released?: boolean; now?: number } = {},
): boolean {
  if (opts.waived || opts.released) return false;
  if (it.storageState !== undefined) return it.storageState === 'overdue';
  return it.status === 'ready' && overdueDays(it.freeUntil, opts.now) > 0;
}
